import React from 'react';

const ChatHeader = ({ 
  title = "AI Agent", 
  subtitle = "Intelligent Assistant",
  avatar = "🤖",
  gradientFrom = "#831f82",
  gradientTo = "#2e0059"
}) => {
  return (
    <div 
      className="flex items-center p-4 text-white"
      style={{ background: `linear-gradient(to right, ${gradientFrom}, ${gradientTo})` }}
    >
      <div className="w-10 h-10 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center text-lg mr-3">
        {avatar}
      </div>
      <div>
        <h3 className="font-semibold text-white">{title}</h3>
        <p className="text-sm text-purple-100 flex items-center">
          {subtitle}
        </p>
      </div>
    </div>
  );
};

export default ChatHeader;